export default class OperationApproval {
    constructor(operationId, approved) {
        this.operationId = operationId
        this.approved = approved
    }
}